import { axiosObject } from "../config";

export default function googleLogin(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = "access/login/google";
    payload["redirect_to"] = process.env.NEXT_PUBLIC_GOOGLE_REDIRECT_URL;
    axiosObject
      .get(uri, { params: payload })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
